/**
 * Spacing values.
 */
export default [4, 8, 16, 24, 32, 40, 48, 56, 64, 128, 256, 512];
